// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import DocumentMeta from 'react-document-meta'
import { withRouter, Switch, Route } from 'react-router-dom'

// Internal Dependencies:
import PageData from 'containers/PageData'
// import { getUrlParameter } from 'utilities/url'
import SiteLayout from 'layouts/SiteLayout'
import BasicPageLayout from 'layouts/BasicPageLayout'

import Home from 'pages/home/Home'
// import Blog from 'pages/blog/Blog'

import { get } from 'utilities/objects'

// Redux:
import { getScreenSize } from 'actions/site'


class SiteContainer extends React.Component {
	componentDidMount() {
		window.addEventListener( 'resize', this.onResize )
	}

	componentDidUpdate( prevProps ) {

	}

	onResize = () => {
		this.props.dispatch( getScreenSize() )
	}

	render() {
		const meta = {
			title: siteData.site_name
		}

		return [
			<DocumentMeta { ...meta } key="DocumentMeta" />,
			<PageData { ...this.props } key="PageData" />,

			<SiteLayout { ...this.props } key="SiteLayout">
				<Switch key="Switch">
					<Route path="/" exact render={ props => (
						<Home { ...props } />
					) } />

					{/*<Route path="/blog" exact render={ props => (
						<Blog { ...props } />
					) } />*/}

					<Route path="/:page/page/:archivePageNumber" exact render={ props => (
						<BasicPageLayout { ...props } />
					) } />

					<Route path="/:page" exact render={ props => (
						<BasicPageLayout { ...props } />
					) } />

					<Route path="/:page/:subpage" exact render={ props => (
						<BasicPageLayout { ...props } />
					) } />
				</Switch>
			</SiteLayout>
		]
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {

	}
}

export default withRouter(
	connect( mapStateToProps )( SiteContainer )
)



// WEBPACK FOOTER //
// ./containers/SiteContainer.jsx